// src/pages/Confirmation.js
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getVentePublique } from "../services/db";
import { QRCodeSVG } from "qrcode.react";

export default function Confirmation() {
  const { venteId, orgId, tombolaId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getVentePublique(venteId, orgId, tombolaId).then((d) => {
      setData(d);
      setLoading(false);
    });
  }, [venteId]);

  if (loading) return <div style={s.center}>⏳ Chargement…</div>;
  if (!data) return <div style={s.center}>❌ Billet introuvable.</div>;

  const { tombola, vente } = data;
  const confirmUrl = `${window.location.origin}/confirmation/${venteId}/${orgId}/${tombolaId}`;
  const lotsUrl = `${window.location.origin}/lots/${tombola.orgId}/${tombola.id}`;

  return (
    <div style={s.wrapper}>
      <div style={s.card}>
        <div style={s.header}>
          <img src="https://app.tombo.live/logo_app.png" alt="TomboLive" style={s.logo} />
          <div style={s.headerSub}>{tombola.nom} {tombola.annee}</div>
        </div>
        <div style={s.confirmBadge}>✅ Achat confirmé</div>
        <div style={s.section}>
          <div style={s.bigName}>{vente.nom}</div>
          {vente.telephone && <div style={s.contact}>📞 {vente.telephone}</div>}
        </div>
        <div style={s.section}>
          <div style={s.sectionTitle}>{vente.quantite} billet(s)</div>
          <div style={s.billetsGrid}>
            {vente.numeros.map((n) => <span key={n} style={s.chip}>#{n}</span>)}
          </div>
        </div>
        <div style={s.qrSection}>
          <QRCodeSVG value={confirmUrl} size={180} level="M" fgColor="#1a3a8f" />
          <div style={s.qrLabel}>Preuve d'achat</div>
          <button onClick={() => navigator.clipboard.writeText(confirmUrl)} style={s.copyBtn}>
            📋 Copier le lien
          </button>
        </div>
        <div style={s.lotsLink} onClick={() => window.open(lotsUrl, "_blank")}>
          🎁 Voir les lots à gagner →
        </div>
        <div style={s.marketingBox}>
          <div style={s.marketingTitle}>🎟️ Vous organisez aussi une tombola ?</div>
          <div style={s.marketingText}>
            Gérez vos ventes, billets et tirage au sort en quelques clics depuis votre smartphone.
            <strong> Essayez TomboLive gratuitement !</strong>
          </div>
          <a href="https://tombo.live" target="_blank" rel="noopener noreferrer" style={s.marketingBtn}>
            Découvrir TomboLive →
          </a>
        </div>
        <div style={s.rgpd}>
          🔒 Vos coordonnées sont utilisées uniquement par{" "}
          <strong>{tombola.organisateur || "l'organisateur"}</strong> pour la gestion de cette tombola
          (contact des gagnants). TomboLive les héberge pour son compte. Pour les consulter ou les faire
          supprimer, contactez l'organisateur ou{" "}
          <a href="mailto:contact@tombo.live" style={{ color: "#888" }}>contact@tombo.live</a>.{" "}
          <a href="https://tombo.live/confidentialite/" target="_blank" rel="noopener noreferrer" style={{ color: "#888" }}>
            Politique de confidentialité
          </a>
        </div>
        <div style={s.footer}>TomboLive · <a href="https://tombo.live" style={{color:"#aaa"}}>tombo.live</a></div>
      </div>
    </div>
  );
}

const s = {
  center:{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.1rem",color:"#667eea"},
  wrapper:{minHeight:"100vh",background:"linear-gradient(135deg,#1a3a8f,#0099cc)",display:"flex",alignItems:"flex-start",justifyContent:"center",padding:"2rem 1rem"},
  card:{background:"#fff",borderRadius:"20px",width:"100%",maxWidth:"420px",overflow:"hidden",boxShadow:"0 20px 60px rgba(0,0,0,0.2)"},
  header:{background:"linear-gradient(135deg,#1a3a8f,#0099cc)",padding:"1.25rem",textAlign:"center"},
  logo:{width:"80px",height:"80px",objectFit:"contain",borderRadius:"12px",marginBottom:"6px"},
  headerSub:{color:"rgba(255,255,255,0.8)",fontSize:"0.88rem"},
  confirmBadge:{background:"#e8f5e9",color:"#2e7d32",padding:"0.75rem",textAlign:"center",fontWeight:"700",fontSize:"1rem"},
  section:{padding:"1rem 1.5rem",borderBottom:"1px solid #f0f0f0"},
  sectionTitle:{fontSize:"0.72rem",fontWeight:"700",color:"#aaa",textTransform:"uppercase",marginBottom:"0.5rem"},
  bigName:{fontSize:"1.4rem",fontWeight:"800",color:"#1a1a2e"},
  contact:{fontSize:"0.88rem",color:"#666",marginTop:"3px"},
  billetsGrid:{display:"flex",flexWrap:"wrap",gap:"6px"},
  chip:{background:"#eef0ff",color:"#4c5ee8",borderRadius:"8px",padding:"4px 12px",fontSize:"0.9rem",fontWeight:"800"},
  qrSection:{padding:"1.25rem 1.5rem",textAlign:"center",borderBottom:"1px solid #f0f0f0"},
  qrLabel:{fontSize:"0.78rem",color:"#aaa",margin:"8px 0 6px"},
  copyBtn:{padding:"6px 16px",background:"#eef0ff",color:"#4c5ee8",border:"1px solid #c7d2ff",borderRadius:"8px",cursor:"pointer",fontSize:"0.82rem",fontWeight:"600"},
  lotsLink:{padding:"0.9rem 1.5rem",background:"#f7f8fc",cursor:"pointer",fontSize:"0.88rem",fontWeight:"600",color:"#4c5ee8",textAlign:"center"},
  marketingBox:{margin:"0",background:"linear-gradient(135deg,#1a3a8f,#764ba2)",padding:"1.25rem 1.5rem",textAlign:"center"},
  marketingTitle:{fontWeight:"800",color:"#fff",fontSize:"0.95rem",marginBottom:"8px"},
  marketingText:{fontSize:"0.82rem",color:"rgba(255,255,255,0.85)",lineHeight:1.6,marginBottom:"14px"},
  marketingBtn:{display:"inline-block",padding:"8px 20px",background:"#fff",color:"#1a3a8f",borderRadius:"20px",textDecoration:"none",fontWeight:"700",fontSize:"0.85rem"},
  rgpd:{padding:"0.85rem 1.25rem",fontSize:"0.7rem",color:"#999",lineHeight:1.5,textAlign:"center",background:"#fafafa"},
  footer:{textAlign:"center",padding:"0.5rem",fontSize:"0.72rem",color:"#bbb"},
};
